export enum MissionCategory {
	Overview,
	// fake category for custom section overview missions, using in TSMap.to get correct missions
	CustomSectionOverview,
	Available,
	Locked,
	Completed,
	Missed,
}